import React, { useState, useEffect } from "react";
import Main from "../components/layout/Main";
import backArrow from "../assets/images/backArrow.png";
import Table from 'react-bootstrap/Table';
import useRequest from "../hooks/useRequest";
import { useNavigate, useParams } from "react-router-dom";

function AllScoreData() {
  const { request } = useRequest();
  const [gameData, setGameData] = useState({})
  const [scoreData, setScoreData] = useState([])
  const [scoreGame, setScoreGame] = useState([])
  const [totalGameHoles, setTotalGameHoles] = useState(18) // Default to 18
  const [holeCount, setHoleCount] = useState(18); // Default to 18 holes
  const [CraetorID, setCreatorId] = useState(null)
  const [skinsData, setSkinsData] = useState(null) // New state for skins data

  const { id } = useParams();
  const navigate = useNavigate();

  function formatCreatedAt(createdAt) {
    const date = new Date(createdAt);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${month}/${day}/${year} - DURATION: ${hours}H ${minutes}M`;
  }

  useEffect(()=>{
    getScoreGame(id)
  },[CraetorID])

  useEffect(() => {
    if (id != null) {
      request({
        url: `app/game/game-detail/${id}`,
        method: 'GET',
        onSuccess: (data) => {
          setGameData(data.data)
          setCreatorId(data.data.user._id)

          // Determine total holes for the game
          const gameHoles = data.data.holes || 18
          setTotalGameHoles(gameHoles)
          setHoleCount(data.data.holes || 18);
          
          // Check if game format is Skins and fetch skins data
          if (data.data.gameFormat === "Skins") {
            setSkinsData(data.data.skinsData || null);
          }
          
          getScoreGame(id)
          console.log("all data", data.data)
          scoreDataDetail(data.data?.course, data.data?.courseTee?._id)
        },
        onError: (error) => {
          console.log(error);
        }
      })
    }
  }, [id])

  const getScoreGame = (id) => {
    request({
      url: `app/score/get-score-game/${id}`,
      method: 'GET',
      onSuccess: (data) => {
        const gameDetailsId = () => {
          return [...data.data.data].sort((a, b) => {
            console.log("udta", a.userData._id, "creator", CraetorID)
            if (a.userData._id === CraetorID) return -1;
            if (b.userData._id === CraetorID) return 1;
            return 0;
          });
        };
                  
        const updatedGameDetails =  gameDetailsId() ;
        setScoreGame(updatedGameDetails);
      },
      onError: (error) => {
        console.log(error);
      }
    })
  }

  const scoreDataDetail = (courseId, teeId) => {
    request({
      url: `common/scoreData/${courseId}/${teeId}`,
      method: "GET",
      onSuccess: (data) => {
        setScoreData(data.data.data)
      },
      onError: (error) => {
        console.log(error);
      }
    })
  }

  // Get player's score for a specific hole
  const getPlayerScore = (playerData, hole) => {
    const score = playerData?.data?.find(
      score => parseInt(score.scoreRound) === hole
    );
    return score?.scoreValue != null ? score.scoreValue : '-';
  }

  // Calculate player's total score for entire game (holes 1-max)
  const calculatePlayerTotalScore = (playerData) => {
    return playerData?.data
      ?.filter(score => 
        parseInt(score.scoreRound) >= 1 && 
        parseInt(score.scoreRound) <= totalGameHoles
      )
      .reduce((sum, score) => sum + (parseInt(score.scoreValue) || 0), 0);
  }

  // Calculate player's score for first 9 holes
  const calculateFirstNinePlayerTotal = (playerData) => {
    return playerData?.data
      ?.filter(score => 
        parseInt(score.scoreRound) >= 1 && 
        parseInt(score.scoreRound) <= 9
      )
      .reduce((sum, score) => sum + (parseInt(score.scoreValue) || 0), 0);
  }

  // Calculate player's score for last 9 holes
  const calculateLastNinePlayerTotal = (playerData) => {
    return playerData?.data
      ?.filter(score => 
        parseInt(score.scoreRound) >= 10 && 
        parseInt(score.scoreRound) <= 18
      )
      .reduce((sum, score) => sum + (parseInt(score.scoreValue) || 0), 0);
  }

  // Get skins winner for a specific hole
  const getSkinsWinner = (hole) => {
    if (!skinsData?.skinsWon || gameData.gameFormat !== "Skins") return null;
    
    const holeWinner = skinsData.skinsWon.find(
      skin => skin.hole === hole && !skin.isTie
    );
    
    return holeWinner;
  }

  // Check if player won a specific hole in skins
  const isSkinsWinner = (playerData, hole) => {
    const winner = getSkinsWinner(hole);
    return winner && winner.winner === playerData.userData._id;
  }

  // Get player's total skins won
  const getPlayerSkinsTotal = (playerData) => {
    if (!skinsData?.playerSkinsTotals || gameData.gameFormat !== "Skins") return 0;
    
    const playerSkins = skinsData.playerSkinsTotals.find(
      player => player.playerId === playerData.userData._id
    );
    
    return playerSkins?.skinsWon || 0;
  }

  // Hole columns including first 9, out, last 9, in, and total
  const holeColumns = [
    ...Array.from({length: 9}, (_, i) => i + 1),
    'Out',
    ...(totalGameHoles > 9 ? 
      [...Array.from({length: 9}, (_, i) => i + 10), 'In'] : 
      []
    ),
    'Total'
  ];

  return (
    <Main>
      <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="pagreHeader">
              <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
                <button onClick={() => navigate("/career-scorecard")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
                  <img className="h-100" src={backArrow} alt="Back" />
                </button>
                <div className="txt">Game Details</div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="gameDetailCard bg-white p-3 d-flex flex-column gap-3">
              <div className="cardOne d-sm-flex align-items-center justify-content-between">
                <div className="">
                  <div className="value">
                    {gameData.createdAt && formatCreatedAt(gameData.createdAt)}
                  </div>
                  <div className="title mt-1">{gameData?.courseData?.name}</div>
                </div>
                <div className="text-sm-end mt-sm-0 mt-2">
                  <div className="title">{holeCount}-Hole Game</div>
                  {gameData.gameFormat && (
                    <div className="value mt-1">Format: {gameData.gameFormat}</div>
                  )}
                </div>
              </div>
              <div className="cardOne border-bottom pb-3">
                <div className="row g-3">
                  <div className="col-lg-3 col-sm-4">
                    <div className="title">{gameData?.courseTee?.name}</div>
                    <div className="value mt-1">Tee</div>
                  </div>
                  <div className="col-xxl-2 col-md-3 col-sm-4">
                    <div className="title">{gameData?.courseTee?.rating}/{gameData?.courseTee?.slope}</div>
                    <div className="value mt-1">Course Rating/Slope</div>
                  </div>
                  <div className="col-xxl-2 col-md-3 col-sm-4">
                    <div className="title">
                      {scoreData
                        .filter(item => 
                          item.hole !== null && 
                          parseInt(item.hole) >= 1 && 
                          parseInt(item.hole) <= totalGameHoles
                        )
                        .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
                      }
                    </div>
                    <div className="value mt-1">Course Par</div>
                  </div>
                </div>
              </div>
              <div className="cardOne">
                <div className="row g-3">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <div className="title">{gameData?.putts}</div>
                    <div className="value mt-1">Total putts</div>
                  </div>
                  {gameData.gameFormat === "Skins" && skinsData && (
                    <div className="col-lg-3 col-sm-4 col-6">
                      <div className="title">{skinsData.carryOverSkins || 0}</div>
                      <div className="value mt-1">Carry Over Skins</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="gameDetailCard bg-white d-flex flex-column gap-3">
              <div className="gameDetailTable">
                <Table responsive className="m-0">
                  <thead>
                    <tr className="headerFirst">
                      <th colSpan={2}>Hole</th>
                      {holeColumns.map((hole, index) => (
                        <th key={index}>{hole}</th>
                      ))}
                    </tr>
                    <tr className="headerSecond">
                      <th colSpan={2}>Par <br /> Handicap</th>
                      {holeColumns.map((hole, index) => {
                        // Special handling for Out, In, and Total columns
                        if (hole === 'Out') {
                          return (
                            <th key={index}>
                              {scoreData
                                .filter(item => 
                                  item.hole !== null && 
                                  parseInt(item.hole) >= 1 && 
                                  parseInt(item.hole) <= 9
                                )
                                .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
                              }<br />
                              -
                            </th>
                          );
                        }
                        if (hole === 'In' && totalGameHoles > 9) {
                          return (
                            <th key={index}>
                              {scoreData
                                .filter(item => 
                                  item.hole !== null && 
                                  parseInt(item.hole) >= 10 && 
                                  parseInt(item.hole) <= 18
                                )
                                .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
                              }<br />
                              -
                            </th>
                          );
                        }
                        if (hole === 'Total') {
                          return (
                            <th key={index}>
                              {scoreData
                                .filter(item => 
                                  item.hole !== null && 
                                  parseInt(item.hole) >= 1 && 
                                  parseInt(item.hole) <= totalGameHoles
                                )
                                .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
                              }<br />
                              -
                            </th>
                          );
                        }

                        // Normal hole handicap and par
                        const holeData = scoreData.find(
                          item => item.hole === hole.toString()
                        );
                        return (
                          <th key={index}>
                            {holeData?.par || 0}<br />
                            {holeData?.handicap || 0}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {scoreGame?.map((playerData, index) => (
                      <tr key={index}>
                        <td colSpan={2}>
                          <div className="playerProfile">
                            <div className="profileImg">
                              <img
                                className="w-100 h-100"
                                src={
                                  playerData?.userData?.profilePic
                                    ? `https://pwabucket1.s3.amazonaws.com/${playerData?.userData?.profilePic}`
                                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                      playerData?.userData?.name
                                    )}&size=256`
                                }
                                alt={playerData.userData.name}
                              />
                            </div>
                            <div className="name">{playerData.userData.name}</div>
                            {gameData.gameFormat === "Skins" && (
                              <div className="skinsWon text-muted small">
                                Skins: {getPlayerSkinsTotal(playerData)}
                              </div>
                            )}
                          </div>
                        </td>
                        {holeColumns.map((hole, idx) => {
                          if (hole === 'Out') {
                            const firstNineTotal = calculateFirstNinePlayerTotal(playerData);
                            return (
                              <td key={idx}>
                                <div className="d-flex flex-column gap-2">
                                  <div className="scoreType">
                                    {firstNineTotal}
                                  </div>
                                </div>
                              </td>
                            );
                          }
                          if (hole === 'In' && totalGameHoles > 9) {
                            const lastNineTotal = calculateLastNinePlayerTotal(playerData);
                            return (
                              <td key={idx}>
                                <div className="d-flex flex-column gap-2">
                                  <div className="scoreType">
                                    {lastNineTotal}
                                  </div>
                                </div>
                              </td>
                            );
                          }
                          if (hole === 'Total') {
                            const playerTotalScore = calculatePlayerTotalScore(playerData);
                            return (
                              <td key={idx}>
                                <div className="d-flex flex-column gap-2">
                                  <div className="scoreType">
                                    {gameData.gameFormat === "Skins" ? getPlayerSkinsTotal(playerData) : playerTotalScore}
                                  </div>
                                </div>
                              </td>
                            );
                          }

                          // Regular hole - check for skins winner
                          const isWinner = gameData.gameFormat === "Skins" && isSkinsWinner(playerData, hole);
                          const winner = getSkinsWinner(hole);
                          
                          return (
                            <td 
                              key={idx} 
                              className={isWinner ? "skins-winner" : ""}
                              style={isWinner ? { 
                                backgroundColor: "#d4edda", 
                                fontWeight: "bold",
                                position: "relative"
                              } : {}}
                            >
                              <div className="d-flex flex-column gap-2">
                                <div className="scoreType">
                                  {getPlayerScore(playerData, hole)}
                                  {isWinner && (
                                    <span className="skins-indicator" style={{
                                      fontSize: "10px",
                                      color: "#155724",
                                      marginLeft: "5px"
                                    }}>
                                      🏆
                                    </span>
                                  )}
                                </div>
                              </div>
                              {gameData.gameFormat === "Skins" && winner && winner.isTie && (
                                <div style={{
                                  fontSize: "8px",
                                  color: "#856404",
                                  textAlign: "center"
                                }}>
                                  TIE
                                </div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add custom CSS for skins styling */}
      <style jsx>{`
        .skins-winner {
          border: 2px solid #28a745 !important;
        }
        
        .skins-indicator {
          animation: pulse 2s infinite;
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        
        .skinsWon {
          font-size: 11px;
          margin-top: 2px;
        }
      `}</style>
    </Main>
  );
}

export default AllScoreData;









// import React, { useState, useEffect } from "react";
// import Main from "../components/layout/Main";
// import backArrow from "../assets/images/backArrow.png";
// import Table from 'react-bootstrap/Table';
// import useRequest from "../hooks/useRequest";
// import { useNavigate, useParams } from "react-router-dom";

// function AllScoreData() {
//   const { request } = useRequest();
//   const [gameData, setGameData] = useState({})
//   const [scoreData, setScoreData] = useState([])
//   const [scoreGame, setScoreGame] = useState([])
//   const [totalGameHoles, setTotalGameHoles] = useState(18) // Default to 18
//   const [holeCount, setHoleCount] = useState(18); // Default to 18 holes
//   const [CraetorID, setCreatorId] = useState(null)

//   const { id } = useParams();
//   const navigate = useNavigate();

//   function formatCreatedAt(createdAt) {
//     const date = new Date(createdAt);
//     const year = date.getFullYear();
//     const month = (date.getMonth() + 1).toString().padStart(2, '0');
//     const day = date.getDate().toString().padStart(2, '0');
//     const hours = date.getHours().toString().padStart(2, '0');
//     const minutes = date.getMinutes().toString().padStart(2, '0');
//     return `${month}/${day}/${year} - DURATION: ${hours}H ${minutes}M`;
//   }

//     useEffect(()=>{
//       getScoreGame(id)
//     },[CraetorID])

//   useEffect(() => {
//     if (id != null) {
//       request({
//         url: `app/game/game-detail/${id}`,
//         method: 'GET',
//         onSuccess: (data) => {
//           setGameData(data.data)
//           // Determine total holes for the game
//           setCreatorId(data.data.user._id)

//           const gameHoles = data.data.holes || 18
//           setTotalGameHoles(gameHoles)
//           setHoleCount(data.data.holes || 18);
//           getScoreGame(id)
//           console.log("all data", data.data)
//           scoreDataDetail(data.data?.course, data.data?.courseTee?._id)
//         },
//         onError: (error) => {
//           console.log(error);
//         }
//       })
//     }
//   }, [id])

//   const getScoreGame = (id) => {
//     request({
//       url: `app/score/get-score-game/${id}`,
//       method: 'GET',
//       onSuccess: (data) => {
//         // setScoreGame(data.data.data)
//         const gameDetailsId = () => {
//           return [...data.data.data].sort((a, b) => {
//             console.log("udta", a.userData._id, "creator", CraetorID)
//             if (a.userData._id === CraetorID) return -1;
//             if (b.userData._id === CraetorID) return 1;
//             return 0;
//           });
//         };
                  
//         const updatedGameDetails =  gameDetailsId() ;
//         setScoreGame(updatedGameDetails);
//       },
//       onError: (error) => {
//         console.log(error);
//       }
//     })
//   }

//   const scoreDataDetail = (courseId, teeId) => {
//     request({
//       url: `common/scoreData/${courseId}/${teeId}`,
//       method: "GET",
//       onSuccess: (data) => {
//         setScoreData(data.data.data)
//       },
//       onError: (error) => {
//         console.log(error);
//       }
//     })
//   }

//   // Get player's score for a specific hole
//   const getPlayerScore = (playerData, hole) => {
//     const score = playerData?.data?.find(
//       score => parseInt(score.scoreRound) === hole
//     );
//     return score?.scoreValue != null ? score.scoreValue : '-';
//   }

//   // Calculate player's total score for entire game (holes 1-max)
//   const calculatePlayerTotalScore = (playerData) => {
//     return playerData?.data
//       ?.filter(score => 
//         parseInt(score.scoreRound) >= 1 && 
//         parseInt(score.scoreRound) <= totalGameHoles
//       )
//       .reduce((sum, score) => sum + (parseInt(score.scoreValue) || 0), 0);
//   }

//   // Calculate player's score for first 9 holes
//   const calculateFirstNinePlayerTotal = (playerData) => {
//     return playerData?.data
//       ?.filter(score => 
//         parseInt(score.scoreRound) >= 1 && 
//         parseInt(score.scoreRound) <= 9
//       )
//       .reduce((sum, score) => sum + (parseInt(score.scoreValue) || 0), 0);
//   }

//   // Calculate player's score for last 9 holes
//   const calculateLastNinePlayerTotal = (playerData) => {
//     return playerData?.data
//       ?.filter(score => 
//         parseInt(score.scoreRound) >= 10 && 
//         parseInt(score.scoreRound) <= 18
//       )
//       .reduce((sum, score) => sum + (parseInt(score.scoreValue) || 0), 0);
//   }

//   // Hole columns including first 9, out, last 9, in, and total
//   const holeColumns = [
//     ...Array.from({length: 9}, (_, i) => i + 1),
//     'Out',
//     ...(totalGameHoles > 9 ? 
//       [...Array.from({length: 9}, (_, i) => i + 10), 'In'] : 
//       []
//     ),
//     'Total'
//   ];

//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//         <div className="row">
//           <div className="col-lg-12">
//             <div className="pagreHeader">
//               <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
//                 <button onClick={() => navigate("/career-scorecard")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
//                   <img className="h-100" src={backArrow} alt="Back" />
//                 </button>
//                 <div className="txt">Game Details</div>
//               </div>
//             </div>
//           </div>
//           <div className="col-12">
//             <div className="gameDetailCard bg-white p-3 d-flex flex-column gap-3">
//               <div className="cardOne d-sm-flex align-items-center justify-content-between">
//                 <div className="">
//                   <div className="value">
//                     {gameData.createdAt && formatCreatedAt(gameData.createdAt)}
//                   </div>
//                   <div className="title mt-1">{gameData?.courseData?.name}</div>
//                 </div>
//                 <div className="text-sm-end mt-sm-0 mt-2">
//                   <div className="title">{holeCount}-Hole Game</div>
//                 </div>
//               </div>
//               <div className="cardOne border-bottom pb-3">
//                 <div className="row g-3">
//                   <div className="col-lg-3 col-sm-4">
//                     <div className="title">{gameData?.courseTee?.name}</div>
//                     <div className="value mt-1">Tee</div>
//                   </div>
//                   <div className="col-xxl-2 col-md-3 col-sm-4">
//                     <div className="title">{gameData?.courseTee?.rating}/{gameData?.courseTee?.slope}</div>
//                     <div className="value mt-1">Course Rating/Slope</div>
//                   </div>
//                   <div className="col-xxl-2 col-md-3 col-sm-4">
//                     <div className="title">
//                       {scoreData
//                         .filter(item => 
//                           item.hole !== null && 
//                           parseInt(item.hole) >= 1 && 
//                           parseInt(item.hole) <= totalGameHoles
//                         )
//                         .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
//                       }
//                     </div>
//                     <div className="value mt-1">Course Par</div>
//                   </div>
//                 </div>
//               </div>
//               <div className="cardOne">
//                 <div className="row g-3">
//                   <div className="col-lg-3 col-sm-4 col-6">
//                     <div className="title">{gameData?.putts}</div>
//                     <div className="value mt-1">Total putts</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-12">
//             <div className="gameDetailCard bg-white d-flex flex-column gap-3">
//               <div className="gameDetailTable">
//                 <Table responsive className="m-0">
//                   <thead>
//                     <tr className="headerFirst">
//                       <th colSpan={2}>Hole</th>
//                       {holeColumns.map((hole, index) => (
//                         <th key={index}>{hole}</th>
//                       ))}
//                     </tr>
//                     <tr className="headerSecond">
//                       <th colSpan={2}>Par <br /> Handicap</th>
//                       {holeColumns.map((hole, index) => {
//                         // Special handling for Out, In, and Total columns
//                         if (hole === 'Out') {
//                           return (
//                             <th key={index}>
//                               {scoreData
//                                 .filter(item => 
//                                   item.hole !== null && 
//                                   parseInt(item.hole) >= 1 && 
//                                   parseInt(item.hole) <= 9
//                                 )
//                                 .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
//                               }<br />
//                               -
//                             </th>
//                           );
//                         }
//                         if (hole === 'In' && totalGameHoles > 9) {
//                           return (
//                             <th key={index}>
//                               {scoreData
//                                 .filter(item => 
//                                   item.hole !== null && 
//                                   parseInt(item.hole) >= 10 && 
//                                   parseInt(item.hole) <= 18
//                                 )
//                                 .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
//                               }<br />
//                               -
//                             </th>
//                           );
//                         }
//                         if (hole === 'Total') {
//                           return (
//                             <th key={index}>
//                               {scoreData
//                                 .filter(item => 
//                                   item.hole !== null && 
//                                   parseInt(item.hole) >= 1 && 
//                                   parseInt(item.hole) <= totalGameHoles
//                                 )
//                                 .reduce((sum, item) => sum + (parseInt(item.par) || 0), 0)
//                               }<br />
//                               -
//                             </th>
//                           );
//                         }

//                         // Normal hole handicap and par
//                         const holeData = scoreData.find(
//                           item => item.hole === hole.toString()
//                         );
//                         return (
//                           <th key={index}>
//                             {holeData?.par || 0}<br />
//                             {holeData?.handicap || 0}
//                           </th>
//                         );
//                       })}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {scoreGame?.map((playerData, index) => (
//                       <tr key={index}>
//                         <td colSpan={2}>
//                           <div className="playerProfile">
//                             <div className="profileImg">
//                               <img
//                                 className="w-100 h-100"
//                                 src={
//                                   playerData?.userData?.profilePic
//                                     ? `https://pwabucket1.s3.amazonaws.com/${playerData?.userData?.profilePic}`
//                                     : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                       playerData?.userData?.name
//                                     )}&size=256`
//                                 }
//                                 alt={playerData.userData.name}
//                               />
//                             </div>
//                             <div className="name">{playerData.userData.name}</div>
//                           </div>
//                         </td>
//                         {holeColumns.map((hole, idx) => {
//                           if (hole === 'Out') {
//                             const firstNineTotal = calculateFirstNinePlayerTotal(playerData);

                            
//                             return (
//                               <td key={idx}>
//                                 <div className="d-flex flex-column gap-2">
//                                   <div className="scoreType">
//                                     {firstNineTotal }
//                                   </div>
//                                 </div>
//                               </td>
//                             );
//                           }
//                           if (hole === 'In' && totalGameHoles > 9) {
//                             const lastNineTotal = calculateLastNinePlayerTotal(playerData);

//                             return (
//                               <td key={idx}>
//                                 <div className="d-flex flex-column gap-2">
//                                   <div className="scoreType">
//                                     {lastNineTotal }
//                                   </div>
//                                 </div>
//                               </td>
//                             );
//                           }
//                           if (hole === 'Total') {
//                             const playerTotalScore = calculatePlayerTotalScore(playerData);
                            
//                             return (
//                               <td key={idx}>
//                                 <div className="d-flex flex-column gap-2">
//                                   <div className="scoreType">
//                                     {playerTotalScore}
//                                   </div>
//                                 </div>
//                               </td>
//                             );
//                           }
//                           return (
//                             <td key={idx}>
//                               <div className="d-flex flex-column gap-2">
//                                 <div className="scoreType">
//                                   {getPlayerScore(playerData, hole)}
//                                 </div>
//                               </div>
//                             </td>
//                           );
//                         })}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </Main>
//   );
// }

// export default AllScoreData;
